import { RestClient } from '@libs/rest-client';
import { BookSetting, type BookSettingRaw } from '../models';

async function fetchBookSetting() {
  return BookSetting.fromRaw(await RestClient.fa.post<BookSettingRaw>('/book/all'));
}

export { fetchBookSetting };
